import { CircularProgress, Container } from '@material-ui/core'
import React from 'react'
import About from './About'
import FAQ from './FAQ'
import Gallery_Location from './Gallery_Location'
import Intro from './Intro'
import Timetable from './Timetable'
import Presenters from './Presenters'
import SingUp from './SingUp'
import Contact from './Contact'
import Sponsors from './Sponsors'
import Timer from './Timer'






function Main(props) {
  const {pageState} = props;

  function formatTime(time){
    let date = new Date (time)
    console.log(date)
    return date
  }
    
    return (
       
            <div>
               
                
                <Intro intro = {pageState.intro} id="intro"/>
                
                <About about = {pageState.konferencija} id="about"/>
                
                
                <Presenters presenters={pageState.izlagaci} id="presenters"/>

                <Timer date={new Date(pageState.timer)}></Timer>
              
                <Timetable raspored={pageState.raspored}  id="raspored"/>
               
                <Gallery_Location id="slike"/>
               
                <FAQ faqs={pageState.faq}  />
               
                <SingUp id="prijavise"/>
               
                <Contact kontakt={pageState.kontakt} id="kontakt"/>

                <Sponsors/>
               
            </div>
        )
         
    
    
    
}

export default Main
